import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

const flexColumn: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
};

export const root: SxStyle = {};

export const cardContent: SxStyle = {
  padding: (p) => p.spacing(1.5),
  gap: (p) => p.spacing(3),
  display: 'flex',
  flexDirection: 'column',
};

export const shadow: SxStyle = {};

export const summary: SxStyleFunc<boolean | undefined> = (open) => ({
  background: open
    ? (p) => p.palette.primary[50]
    : (p) => p.palette.common.white,
  borderRadius: open ? (p) => p.spacing(1, 1, 0, 0) : (p) => p.spacing(1),
  borderColor: (p) => p.palette.primary[100],
  paddingLeft: (p) => `${p.spacing(1.5)} !important`,
  paddingRight: (p) => `${p.spacing(2)} !important`,
});

export const detail: SxStyleFunc<boolean | undefined> = () => ({
  ...flexColumn,
  gap: (p) => p.spacing(1),
  borderColor: (p) => p.palette.primary[100],
  borderRadius: (p) => p.spacing(0, 0, 1, 1),
});

export const dashed: SxStyle = {
  borderStyle: 'dashed',
};

// export const badge: SxStyleFunc<boolean | undefined> = (expanded) => ({
//   fontSize: (p) => p.typography.body4,
//   background: expanded
//     ? (p) => p.palette.common.white
//     : (p) => p.palette.primary[100],
//   color: (p) => p.palette.primary[500],
//   width: (p) => p.spacing(2.5),
//   height: (p) => p.spacing(2.5),
//   textAlign: 'center',
//   borderRadius: '50%',
//   fontWeight: 500,
// });
